import { z } from 'src/lib'
import { OperacionContraparteCuentaFields, OperacionContraparteFields } from './fields'
import { schemaEntityWithId } from 'src/types'

export const schemaOperacionContraparte = z
    .object({
        [OperacionContraparteFields.CodPais]: z.number(),
        [OperacionContraparteFields.NombrePais]: z.string(),
        [OperacionContraparteFields.CodEstado]: z.number(),
        [OperacionContraparteFields.CodSectorComercial]: z.number(),
        [OperacionContraparteFields.NombreSectorComercial]: z.string(),
        [OperacionContraparteFields.FechaVencimiento]: z.coerce.date(),
        [OperacionContraparteFields.FechaAprobacion]: z.coerce.date(),
        [OperacionContraparteFields.IdUsuarioAlta]: z.number(),
        [OperacionContraparteFields.NombreUsuarioAlta]: z.string(),
        [OperacionContraparteFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionContraparteFields.MailUsuarioAlta]: z.string(),
        [OperacionContraparteFields.PermiteEditar]: z.boolean(),
        [OperacionContraparteFields.PermiteEliminar]: z.boolean()
    })
    .merge(schemaEntityWithId)

export type OperacionContraparte = z.infer<typeof schemaOperacionContraparte>

export const schemaFormOperacionContraparte = z
    .object({
        [OperacionContraparteFields.FechaAprobacion]: z.date(),
        [OperacionContraparteFields.FechaVencimiento]: z.date(),
        [OperacionContraparteFields.CodSectorComercial]: z.number()
    })
    .refine(
        schema =>
            schema.fechaVencimiento ? schema.fechaVencimiento.getTime() >= schema.fechaAprobacion.getTime() : true, // No uso computed key porque: https://github.com/microsoft/TypeScript/issues/10530
        {
            message: 'La fecha de vencimiento debe ser mayor a la fecha de emisión.',
            path: [OperacionContraparteFields.FechaVencimiento]
        }
    )

export type FormOperacionContraparte = z.infer<typeof schemaFormOperacionContraparte>

const schemaDetalle = z
    .object({
        [OperacionContraparteCuentaFields.Sector]: z.string(),
        [OperacionContraparteCuentaFields.ImporteConcertacion]: z.number(),
        [OperacionContraparteCuentaFields.ImporteDPV]: z.number(),
        [OperacionContraparteCuentaFields.ImporteFOP]: z.number(),
        [OperacionContraparteCuentaFields.PermiteModificar]: z.boolean(),
        [OperacionContraparteCuentaFields.Estilo]: z.string().nullable(),
    })
    .merge(schemaEntityWithId)

export type CuentaContraparteDetalle = z.infer<typeof schemaDetalle>

export const schemaCuentaContraparte = z
    .object({
        [OperacionContraparteCuentaFields.NroCuenta]: z.string(),
        [OperacionContraparteCuentaFields.RazonSocial]: z.string(),
        [OperacionContraparteCuentaFields.CodMoneda]: z.number(),
        [OperacionContraparteCuentaFields.DescMoneda]: z.string(),
        [OperacionContraparteCuentaFields.SimboloMoneda]: z.string(),
        [OperacionContraparteCuentaFields.Detalles]: z.array(schemaDetalle)
    })
    .merge(schemaEntityWithId)

export const schemaCuentasContraparte = z.array(schemaCuentaContraparte)

export type CuentaContraparte = z.infer<typeof schemaCuentaContraparte>
export type CuentasContraparte = z.infer<typeof schemaCuentasContraparte>
